import { AppTopBar } from '../AppTopBar';

export function ProviderTopBar() {
  return (
    <AppTopBar
      homeTo="/provider"
      homeAriaLabel="UMB eVault — Provider home"
    />
  );
}
